import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
    'fvScoreInput',
    'submit',
    'range',
  ]

  static values = {
    tourId: Number
  }

  connect() {
    this.rangeTargets.forEach(range => {
      range.addEventListener('change', this.handleRangeChange.bind(this))
    })

    this.maxAllowedPoints = this.rangeTargets.length * 100
  }

  checkInputs() {
    let values = []

    for (const input of this.fvScoreInputTargets) {
      values.push(input.value)

      if(values.includes('')) {
        this.disableSubmit()
      } else {
        this.enableSubmit()
      }
    }
  }

  disableSubmit() {
    this.submitTarget.disabled = true
  }

  enableSubmit() {
    this.submitTarget.disabled = false
  }

  handleRangeChange(event) {
    // Get the range input that's being changed
    const currentRange = event.target, currentValue = parseInt(currentRange.value)
    currentRange.closest('.game').querySelector('.points').innerText = currentValue

    let ranges = this.rangeTargets.filter(range => range !== currentRange),
      rangeTotal = ranges.reduce((acc, range) => acc + parseInt(range.value), 0),
      allowedTotal = this.maxAllowedPoints - currentValue,
      diffTotal = allowedTotal - rangeTotal

    let sort = (a, b) => {
      if(diffTotal > 0) { return b.value - a.value } else { return a.value - b.value }
    }

    ranges = ranges.sort(sort)

    let undistributed = diffTotal, undistributedCount = ranges.length
    ranges.forEach(range => {
      const diff = this.signed_ceil(undistributed / undistributedCount)

      let currentValue = parseInt(range.value),
        newValue = diff < 0 ? Math.max(currentValue + diff, 50) : Math.min(currentValue + diff, 200)

      range.value = newValue
      range.closest('.game').querySelector('.points').innerText = newValue

      undistributed -= newValue - currentValue
      undistributedCount -= 1
    })
  }

  signed_ceil(val) {
    let sign = val < 0 ? -1 : 1
    return Math.ceil(Math.abs(val)) * sign
  }
}
